<div class="page-wrapper">
	<app-navbar [showBackButton]="true" />

	<div class="page-content">
		<div class="container py-4">
			<h1 class="page-title mb-4">{{ "Profile" | translate }}</h1>

			<div class="language-card mb-4">
				<label for="language" class="field-label">
					{{ "language" | translate }}:
				</label>
				<span class="language-value">
					{{ getLanguageByCode(selectedLanguage).name }}
				</span>
				<select
					id="language"
					name="language"
					class="language-select language-select-overlay"
					[ngModel]="selectedLanguage"
					(ngModelChange)="selectLanguage(getLanguageByCode($event))"
				>
					@for (lang of languages(); track lang.shortcode) {
					<option [value]="lang.shortcode">{{ lang.name }}</option>
					}
				</select>
			</div>

			<!-- ── Your information ──────────────────────────────── -->
			<p class="section-label mb-2">
				{{ "Profile_Your_Information" | translate }}
			</p>

			<form #profileForm="ngForm" class="info-card mb-4">
				<div class="field-pill">
					<label for="firstName" class="field-label">
						{{ "Name" | translate }}:
					</label>
					<input
						type="text"
						id="firstName"
						name="firstName"
						class="field-input"
						[(ngModel)]="this.firstName"
						required
						#nameField="ngModel"
					>
				</div>
				@if (nameField.invalid && (nameField.dirty || nameField.touched)) {
				<p class="text-danger small mb-0">
					{{ "Profile_Name_Required" | translate }}
				</p>
				}
				<div class="field-pill">
					<label for="surname" class="field-label">
						{{ "Surname" | translate }}:
					</label>
					<input
						type="text"
						id="surname"
						name="surname"
						class="field-input"
						[(ngModel)]="this.surname"
						required
						#surnameField="ngModel"
					>
				</div>
				@if (surnameField.invalid && (surnameField.dirty ||
				surnameField.touched)) {
				<p class="text-danger small mb-0">
					{{ "Profile_Surname_Required" | translate }}
				</p>
				}
				<div class="field-pill">
					<label for="phone" class="field-label">
						{{ "Phone" | translate }}:
					</label>
					<ngx-intl-tel-input
						id="phone"
						name="phone"
						[cssClass]="'field-input intl-tel-input'"
						[numberFormat]="PhoneNumberFormat.National"
						[(ngModel)]="this.phone"
						[selectedCountryISO]="countryIso(phone?.countryCode)"
						[onlyCountries]="onlyCountries"
						[phoneValidation]="false"
						[enablePlaceholder]="true"
						customPlaceholder="{{ 'YourNumber' | translate }}"
						required
						#phoneField="ngModel"
					/>
				</div>
				@if (phoneField.invalid && (phoneField.dirty || phoneField.touched)) {
				<p class="text-danger small mb-0">
					{{ "Profile_Phone_Required" | translate }}
				</p>
				}
				<div class="field-pill">
					<label for="email" class="field-label">
						{{ "Profile_Mail" | translate }}:
					</label>
					<input
						type="email"
						id="email"
						name="email"
						class="field-input"
						[(ngModel)]="this.email"
						readonly
					>
				</div>
				<div class="field-pill">
					<label for="sex" class="field-label">
						{{ "face-scan.health-profile.sex.title" | translate }}:
					</label>
					<select
						id="sex"
						name="sex"
						class="field-input field-select"
						[(ngModel)]="this.sex"
					>
						<option value="Unspecified"></option>
						<option value="Male">
							{{ "face-scan.health-profile.sex.male" | translate }}
						</option>
						<option value="Female">
							{{ "face-scan.health-profile.sex.female" | translate }}
						</option>
					</select>
				</div>
				<div class="field-pill">
					<label for="birthday" class="field-label">
						{{ "profile_birthday" | translate }}:
					</label>
					<input
						type="date"
						id="birthday"
						name="birthday"
						class="field-input"
						[(ngModel)]="this.birthday"
						required
						#birthdayField="ngModel"
					>
				</div>
				@if (birthdayField.invalid && (birthdayField.dirty ||
				birthdayField.touched)) {
				<p class="text-danger small mb-0">
					{{ "validation_birthday_required" | translate }}
				</p>
				}
				<div class="field-pill">
					<label for="street" class="field-label">
						{{ "profile_street" | translate }}:
					</label>
					<input
						type="text"
						id="street"
						name="street"
						class="field-input"
						[(ngModel)]="this.street"
						required
						#streetField="ngModel"
					>
				</div>
				@if (streetField.invalid && (streetField.dirty || streetField.touched))
				{
				<p class="text-danger small mb-0">
					{{ "validation_street_required" | translate }}
				</p>
				}
				<div class="field-pill">
					<label for="city" class="field-label">
						{{ "profile_city" | translate }}:
					</label>
					<input
						type="text"
						id="city"
						name="city"
						class="field-input"
						[(ngModel)]="this.city"
						required
						#cityField="ngModel"
					>
				</div>
				@if (cityField.invalid && (cityField.dirty || cityField.touched)) {
				<p class="text-danger small mb-0">
					{{ "validation_city_required" | translate }}
				</p>
				}
				<div class="field-pill">
					<label for="state" class="field-label">
						{{ "profile_state" | translate }}:
					</label>
					<input
						type="text"
						id="state"
						name="state"
						class="field-input"
						[(ngModel)]="this.state"
					>
				</div>
				<div class="field-pill">
					<label for="zipCode" class="field-label">
						{{ "profile_zip_code" | translate }}:
					</label>
					<input
						type="text"
						id="zipCode"
						name="zipCode"
						class="field-input"
						[(ngModel)]="this.zipCode"
						required
						#zipCodeField="ngModel"
					>
				</div>
				@if (zipCodeField.invalid && (zipCodeField.dirty ||
				zipCodeField.touched)) {
				<p class="text-danger small mb-0">
					{{ "validation_zip_code_required" | translate }}
				</p>
				}
				<div class="field-pill">
					<label for="countryCode" class="field-label">
						{{ "profile_country" | translate }}:
					</label>
					<select
						id="countryCode"
						name="countryCode"
						class="field-input field-select"
						[(ngModel)]="this.countryCode"
						required
						#countryCodeField="ngModel"
					>
						<option value=""></option>
						@for (c of countryCodes; track c.id) {
						<option [value]="c.country_code">
							{{ c.name_translation_key | translate }}
						</option>
						}
					</select>
				</div>
				@if (countryCodeField.invalid && (countryCodeField.dirty ||
				countryCodeField.touched)) {
				<p class="text-danger small mb-0">
					{{ "validation_country_required" | translate }}
				</p>
				}
			</form>

			<!-- ── Relatives ──────────────────────────────────────── -->
			<p class="section-label mb-2">{{ "Profile_Relatives" | translate }}</p>
			@for (relative of relatives(); track relative.id) {
			<div class="info-card mb-4">
				<div
					class="field-pill"
					[class.is-invalid]="
						relative.isNew &&
						(relativeNameField.dirty || relativeNameField.touched || relative.validationAttempted) &&
						!relative.name
					"
				>
					<label class="field-label">{{ "Name" | translate }}:</label>
					<input
						type="text"
						class="field-input"
						[name]="'relative-name-' + relative.id"
						[(ngModel)]="relative.name"
						[readonly]="!relative.isNew"
						required
						#relativeNameField="ngModel"
					>
				</div>
				@if ( relative.isNew && (relativeNameField.dirty ||
				relativeNameField.touched || relative.validationAttempted) &&
				!relative.name ) {
				<p class="text-danger small mb-0">
					{{ "Profile_Name_Required" | translate }}
				</p>
				}
				<div
					class="field-pill"
					[class.is-invalid]="
						relative.isNew &&
						(relativeSurnameField.dirty || relativeSurnameField.touched || relative.validationAttempted) &&
						!relative.surname
					"
				>
					<label class="field-label">{{ "Surname" | translate }}:</label>
					<input
						type="text"
						class="field-input"
						[name]="'relative-surname-' + relative.id"
						[(ngModel)]="relative.surname"
						[readonly]="!relative.isNew"
						required
						#relativeSurnameField="ngModel"
					>
				</div>
				@if ( relative.isNew && (relativeSurnameField.dirty ||
				relativeSurnameField.touched || relative.validationAttempted) &&
				!relative.surname ) {
				<p class="text-danger small mb-0">
					{{ "Profile_Surname_Required" | translate }}
				</p>
				}
				<div
					class="field-pill"
					[class.is-invalid]="
						relative.isNew &&
						(relativePhoneField.dirty || relativePhoneField.touched || relative.validationAttempted) &&
						!isPhoneValid(relative.phone)
					"
				>
					<label class="field-label">{{ "Phone" | translate }}:</label>
					<ngx-intl-tel-input
						[id]="'relative-phone-' + relative.id"
						[name]="'relative-phone-' + relative.id"
						[cssClass]="'field-input intl-tel-input'"
						[numberFormat]="PhoneNumberFormat.National"
						[(ngModel)]="relative.phone"
						[selectedCountryISO]="countryIso(relative.phone?.countryCode)"
						[onlyCountries]="onlyCountries"
						[phoneValidation]="false"
						[enablePlaceholder]="true"
						customPlaceholder="{{
							'Profile_Relative_Phone_Placeholder' | translate
						}}"
						[disabled]="!relative.isNew"
						required
						#relativePhoneField="ngModel"
					/>
				</div>
				@if ( relative.isNew && (relativePhoneField.dirty ||
				relativePhoneField.touched || relative.validationAttempted) &&
				!isPhoneValid(relative.phone) ) {
				<p class="text-danger small mb-0">
					{{
						relative.phone?.number
							? ("Profile_Relative_Invalid_Phone" | translate)
							: ("Profile_Phone_Required" | translate)
					}}
				</p>
				}
				<div
					class="field-pill mb-3"
					[class.is-invalid]="
						relative.isNew &&
						(relativeMailField.dirty || relativeMailField.touched || relative.validationAttempted) &&
						!isEmailValid(relative.mail)
					"
				>
					<label class="field-label">{{ "Profile_Mail" | translate }}:</label>
					<input
						type="email"
						class="field-input"
						[name]="'relative-mail-' + relative.id"
						[(ngModel)]="relative.mail"
						[readonly]="!relative.isNew"
						required
						email
						#relativeMailField="ngModel"
					>
				</div>
				@if ( relative.isNew && (relativeMailField.dirty ||
				relativeMailField.touched || relative.validationAttempted) &&
				!isEmailValid(relative.mail) ) {
				<p class="text-danger small mb-3">
					{{ "Profile_Email_Invalid" | translate }}
				</p>
				} @if (relative.error) {
				<p class="text-danger small mb-3">{{ relative.error }}</p>
				} @if (!relative.isNew) {
				<p class="text-muted small mb-3">
					{{ "Profile_Relative_Not_Editable" | translate }}
				</p>
				}

				<div
					class="access-row d-flex justify-content-between align-items-center"
				>
					<span class="access-label fw-bold">{{
						"Profile_Access_All_Data" | translate
					}}</span>
					<div class="form-switch access-switch">
						<input
							type="checkbox"
							class="form-check-input"
							[checked]="relative.accessAllData"
							(change)="toggleRelativeAccess(relative.id, 'accessAllData')"
						>
					</div>
				</div>
				<div
					class="access-row d-flex justify-content-between align-items-center"
				>
					<span class="access-label">{{
						"Profile_Access_Booking" | translate
					}}</span>
					<div class="form-switch access-switch">
						<input
							type="checkbox"
							class="form-check-input"
							[checked]="relative.accessBooking"
							[disabled]="relative.accessAllData"
							(change)="toggleRelativeAccess(relative.id, 'accessBooking')"
						>
					</div>
				</div>
				<div
					class="access-row d-flex justify-content-between align-items-center"
				>
					<span class="access-label">{{
						"Profile_Access_My_Health" | translate
					}}</span>
					<div class="form-switch access-switch">
						<input
							type="checkbox"
							class="form-check-input"
							[checked]="relative.accessMyHealth"
							[disabled]="relative.accessAllData"
							(change)="toggleRelativeAccess(relative.id, 'accessMyHealth')"
						>
					</div>
				</div>
				<div
					class="access-row d-flex justify-content-between align-items-center mb-3"
				>
					<span class="access-label">{{
						"Profile_Access_My_Service" | translate
					}}</span>
					<div class="form-switch access-switch">
						<input
							type="checkbox"
							class="form-check-input"
							[checked]="relative.accessMyService"
							[disabled]="relative.accessAllData"
							(change)="toggleRelativeAccess(relative.id, 'accessMyService')"
						>
					</div>
				</div>
				@if (relative.isNew) {
				<button
					type="button"
					class="btn update-profile-btn w-100 mb-2"
					[disabled]="relative.saving"
					(click)="saveRelative(relative.id)"
				>
					{{ "Profile_Create_Relative_Account" | translate }}
				</button>
				}

				<button
					type="button"
					class="btn delete-relative-btn w-100"
					(click)="deleteRelative(relative.id)"
				>
					{{
						(relative.isNew
							? "Profile_Discard_New_Relative"
							: "Profile_Delete_Relative") | translate
					}}
				</button>
			</div>
			}

			<div class="d-flex flex-column align-items-center mb-4">
				<button
					type="button"
					class="add-relative-btn"
					(click)="addRelative()"
					[attr.aria-label]="'Profile_Add_Relative' | translate"
				>
					<svg
						width="22"
						height="22"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					>
						<line x1="12" y1="5" x2="12" y2="19" />
						<line x1="5" y1="12" x2="19" y2="12" />
					</svg>
				</button>
				<span class="add-relative-label mt-2">{{
					"Profile_Add_Relative" | translate
				}}</span>
			</div>

			<div class="d-flex flex-column">
				<button
					type="button"
					class="btn update-profile-btn"
					(click)="updateProfile(profileForm)"
				>
					{{ "Profile_Update" | translate }}
				</button>
				<div class="secondary-profile-actions mt-3">
					<button
						type="button"
						class="btn cancel-membership-btn"
						(click)="showChangePasswordModal()"
					>
						{{ "Password_Change" | translate }}
					</button>
					<button
						type="button"
						class="btn cancel-membership-btn"
						(click)="showDeleteDataModal()"
					>
						{{ "Profile_Cancel_Membership" | translate }}
					</button>
				</div>
			</div>
			@if (isNativePlatform()) {
			<button
				type="button"
				class="btn logout-btn w-100 mt-3"
				(click)="logout()"
			>
				{{ "User_Logout" | translate }}
			</button>
			}
		</div>
	</div>

	<ng-template #changePasswordModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title text-body" id="change-password-modal-title">
				{{ "Password_Change" | translate }}
			</h4>
			<button
				type="button"
				class="btn-close"
				[attr.aria-label]="'CloseBtn' | translate"
				(click)="modal.dismiss()"
			></button>
		</div>
		<div class="modal-body text-body">
			<form #passwordForm="ngForm">
				<div class="field-pill">
					<label for="currentPassword" class="field-label">
						{{ "Password_Current" | translate }}:
					</label>
					<input
						type="password"
						id="currentPassword"
						name="currentPassword"
						class="field-input"
						[(ngModel)]="currentPassword"
						required
						autocomplete="current-password"
					>
				</div>
				<div class="field-pill">
					<label for="newPassword" class="field-label">
						{{ "Password_New" | translate }}:
					</label>
					<input
						type="password"
						id="newPassword"
						name="newPassword"
						class="field-input"
						[(ngModel)]="newPassword"
						required
						autocomplete="new-password"
						#newPasswordField="ngModel"
					>
				</div>
				@if (newPassword && !isPasswordStrong(newPassword)) {
				<p class="text-danger small mb-0">
					{{ "Password_Requirements" | translate }}
				</p>
				}
				<div class="field-pill">
					<label for="confirmNewPassword" class="field-label">
						{{ "Password_Confirm" | translate }}:
					</label>
					<input
						type="password"
						id="confirmNewPassword"
						name="confirmNewPassword"
						class="field-input"
						[(ngModel)]="confirmNewPassword"
						required
						autocomplete="new-password"
					>
				</div>
				@if (confirmNewPassword && !passwordsMatch()) {
				<p class="text-danger small mb-0">
					{{ "Password_Mismatch" | translate }}
				</p>
				}
			</form>
		</div>
		<div class="modal-footer">
			<button
				type="button"
				class="btn btn-outline-dark"
				(click)="modal.dismiss()"
			>
				{{ "CloseBtn" | translate }}
			</button>
			<button
				type="button"
				class="btn update-profile-btn"
				[disabled]="
					passwordForm.invalid ||
					!isPasswordStrong(newPassword) ||
					!passwordsMatch() ||
					changingPassword
				"
				(click)="changePassword()"
			>
				{{ "Password_Update" | translate }}
			</button>
		</div>
	</ng-template>

	<ng-template #deleteDataModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title text-body" id="delete-data-modal-title">
				{{ "Profile_DeleteData" | translate }}
			</h4>
		</div>
		<div class="modal-body text-body">
			<div class="col-12 px-0">
				<div class="row message w-100 bg-white mx-0">
					<p class="col-12 text-center">
						{{ "Profile_DeleteData_Description1" | translate }}
					</p>
					<p class="col-12 text-center fw-bold">
						{{ "Profile_DeleteData_Description2" | translate }}
					</p>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<button
				type="button"
				class="btn btn-outline-dark"
				(click)="modal.close()"
			>
				{{ "CloseBtn" | translate }}
			</button>
			<button
				type="button"
				class="btn btn-danger"
				(click)="deleteProfile(); modal.close()"
			>
				{{ "Delete" | translate }}
			</button>
		</div>
	</ng-template>

	<ng-template #updatedDataModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title text-body" id="updated-data-modal-title">
				{{ updated_modal_title }}
			</h4>
		</div>
		<div class="modal-body text-body">
			<div class="col-12 px-0">
				<div class="row message w-100 bg-white mx-0">
					<p class="col-12 text-center">{{ updated_modal_text }}</p>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary" (click)="modal.close()">
				{{ "CloseBtn" | translate }}
			</button>
		</div>
	</ng-template>
</div>
